import * as yup from 'yup'

// Regras compartilhadas entre o bloqueio na digitação (BankData.tsx) e a
// validação no submit, para as duas camadas não divergirem.
export const AGENCY_MAX_LENGTH = 4
export const AGENCY_ACCEPTED_CHAR = /\d/
export const AGENCY_LENGTH_MESSAGE =
  'A agência tem no máximo 4 dígitos, sem o dígito verificador'

// Aceita letra (X/P do BB e Bradesco) para não travar quem hoje consegue
// submeter. O backend remove não-dígitos antes de gravar.
export const ACCOUNT_DV_MAX_LENGTH = 1
export const ACCOUNT_DV_ACCEPTED_CHAR = /[0-9xXpP]/
export const ACCOUNT_DV_LENGTH_MESSAGE =
  'O dígito verificador tem 1 caractere — confira se o que ficou no campo é o dígito correto'

export const schemaBankForm = yup.object({
  account: yup.string().required('Número da conta obrigatório'),
  agency: yup
    .string()
    .required('Agência obrigatória')
    .matches(/^\d{1,4}$/, AGENCY_LENGTH_MESSAGE),
  // Um DV errado quebra a transferência: o BankAccount::Encoder monta o
  // account_number concatenando account + account_dv, e a Starkbank rejeita
  // 100% das contas com DV de 2+ caracteres.
  account_dv: yup
    .string()
    .required('Dígito verificador obrigatório')
    .matches(/^[0-9xXpP]$/, ACCOUNT_DV_LENGTH_MESSAGE),
  bank: yup
    .object({
      name: yup.string(),
      uuid: yup.string()
    })
    .required('Selecione um banco')
    .nullable(true)
})

export type BankFormSchema = yup.InferType<typeof schemaBankForm>
